module.exports = __webpack_public_path__ + "img/logo5.7bee39be.png";